import {
  Category,
  ValueOptions,
} from 'apps/web/types/labelled-collection.type';

import {
  createAffectiveCategoryLabels,
  createValueCategoryLabels,
} from '../affective';
import { createCognitiveCategoryLabels } from '../cognitive';
import { createPsychomotorCategoryLabels } from '../psychomotor';

export const createCognitiveCategories = (): Category[] => {
  return createCognitiveCategoryLabels().map((label) => ({
    label,
    items: [],
  }));
};

export const createAffectiveCategories = (): Category[] => {
  return createAffectiveCategoryLabels().map((label) => ({
    label,
    items: [],
  }));
};

export const createPsychomotorCategories = (): Category[] => {
  return createPsychomotorCategoryLabels().map((label) => ({
    label,
    items: [],
  }));
};

export const createValueCategories = (): ValueOptions[] => {
  return createValueCategoryLabels().map((label) => ({
    label,
    items: [],
  }));
};
